export const useSessionStorage = <T,>(key: string) => {
  const getValue = (): T | null => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        const item = window.sessionStorage.getItem(key);
        if (!item) return null;
        
        if (typeof item === 'string' && !item.startsWith('{') && !item.startsWith('[')) {
          return item as unknown as T;
        }
        return JSON.parse(item);
      }
      return null;
    } catch {
      return null;
    }
  };

  const setValue = (value: T) => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        if (value === undefined) {
          window.sessionStorage.removeItem(key);
          return;
        }
        const valueToStore = typeof value === 'string' ? value : JSON.stringify(value);
        window.sessionStorage.setItem(key, valueToStore);
      }
    } catch {
      // Tiho ignoriramo error
    }
  };

  const removeValue = () => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        window.sessionStorage.removeItem(key);
      }
    } catch {
      // Tiho ignoriramo error
    }
  };

  return { setValue, getValue, removeValue };
};